export const siteStructureMetaData = {
    fullWidth: true
}
